import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { CheckboxField } from '../../../store/models/field-models';
import { extractFieldErrorMessages } from '../utils';
import { ValidationRuleType } from '../../../store/models/validator-models';

@Component({
    selector: 'app-checkbox-field',
    templateUrl: './checkbox-field.component.html',
    styleUrls: ['./checkbox-field.component.scss'],
})
export class CheckboxFieldComponent {
    @Input() field: CheckboxField;
    @Input() control: FormControl;
    @Input() fieldId: string;

    constructor(private store: Store, private translate: TranslateService) {}

    get isVisible(): boolean {
        return this.field?.visible !== false;
    }

    get isRequired(): boolean {
        return this.field?.validators?.some((v) => v.type === ValidationRuleType.Required) || false;
    }

    get hasError(): boolean {
        return this.control?.invalid && (this.control?.touched || this.control?.dirty);
    }

    checkboxChange(event: MatCheckboxChange): void {
        if (this.field.events?.onChange) {
            this.field.events.onChange(event.checked).forEach((action) => this.store.dispatch(action));
        }
    }

    get errorMessages(): string[] {
        return extractFieldErrorMessages(this.control, this.field, this.translate);
    }
}
